import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-338fe230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenant-page" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "select-item" }

import { onMounted, ref } from 'vue'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import TenantForm from './components/tenant-form-drawer.vue'
import OperationButtonList from '@/components/operation-button-list'
import { queryTenantPage, deleteTenantInfo, queryTenantTopOrg } from '@/api'
import { useRouter } from 'vue-router'
import { msgbox } from '@/utils'
import { useTenantStore } from '@/stores/tenant'
import packageCheck from './components/package-check.vue'
import Selecttenant from '@/components/select-tenant'
import moment from 'moment'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant',
  setup(__props) {

const tenantStore = useTenantStore()

const formInline: any = ref({
  topOrgId: undefined,
})

const router = useRouter()

const getButtonList = (row: any) => {
  const disabled = tenantStore.topOrgId === row.orgId
  return [
    {
      type: 'edit',
      text: '编辑',
    },
    {
      type: 'delete',
      text: '删除',
      disabled,
    },
    {
      type: 'detail',
      text: '详情',
    },
    {
      type: 'config',
      text: '套餐管理',
      disabled,
    },
  ]
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const col = [
  {
    prop: 'orgName',
    label: '租户名称',
  },
  {
    prop: 'address',
    label: '租户地址',
  },
  {
    prop: 'orgContact',
    label: '联系人',
  },
  {
    prop: 'orgMobile',
    label: '联系电话',
  },
  {
    prop: 'orderPackageName',
    label: '当前套餐',
  },
  {
    prop: 'deviceTotalNum',
    label: '设备数量',
  },
  {
    prop: 'createTime',
    label: '创建时间',
    formatter: ({ createTime }: any) => {
      return moment(createTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'salePerson',
    label: '销售人员',
  },
]

const tableLoading = ref(false)
const tableData: any = ref([])

onMounted(async () => {
  await tenantStore.queryTopOrg()
  fetchList()
})

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryTenantPage({
    ...pageParams.value,
    ...formInline.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const tenantConf: any = ref({
  visible: false,
  data: {},
})

const toTenant = (data = {}) => {
  tenantConf.value = {
    visible: true,
    data,
  }
}

const toDelete = ({ orgId }: any) => {
  msgbox({
    tip: '你确定要删除这个租户吗？',
    thenFn: () => handeDelete({ orgId }),
  })
}

const tenantKey = ref(Math.random())

// 删除租户
const handeDelete = async ({ orgId }: any) => {
  const res: any = await deleteTenantInfo({
    orgId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
    tenantKey.value = Math.random()
  }
}

// 查看详情
const toDetail = ({ orgId }: any) => {
  router.push({
    name: 'tenant-detail',
    query: {
      orgId,
    },
  })
}

const packageConf: any = ref({
  visible: false,
  data: {},
})

const toPackageForm = (data: any) => {
  packageConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: "租户",
            prop: "topOrgId"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Selecttenant), {
                modelValue: formInline.value.topOrgId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.topOrgId) = $event)),
                onChange: fetchList,
                style: {"width":"280px"},
                key: tenantKey.value
              }, null, 8, ["modelValue"]))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_button, {
          onClick: toTenant,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加租户")
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "ws_common_table ws_mt25",
        data: tableData.value
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
            return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
          ...item,
        }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64)),
          _createVNode(_component_el_table_column, {
            width: 380,
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: getButtonList(scope.row),
                scope: scope.row,
                onOnEdit: toTenant,
                onOnDelete: toDelete,
                onOnDetail: toDetail,
                onOnConfig: toPackageForm
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(TenantForm, {
      visible: tenantConf.value.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((tenantConf.value.visible) = $event)),
      data: tenantConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(packageCheck, {
      visible: packageConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((packageConf.value.visible) = $event)),
      data: packageConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})